import { SoundType } from '../providers/ActivityAudioProvider/types';
import { get } from 'lodash';

export const getAudioAssetPathForKey = (data, sound) => {
  const { name, path, category } = sound;

  return {
    name,
    category,
    src: get(data, path, {}),
  } as SoundType;
};
